import { render } from "./FooterSection.vue?vue&type=template&id=21df71b8"
const script = {}

import "./FooterSection.vue?vue&type=style&index=0&id=21df71b8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__